exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".autocomplete-autocomplete-14IKJCEjmwr{max-width:300px}input.autocomplete-input-54jl6Xfjmwr,.autocomplete-input-54jl6Xfjmwr input{max-width:100%}.autocomplete-autocomplete-input-wrapper-1lhySFZlmwr{flex:1}\n", ""]);
// Exports
exports.locals = {
	"autocomplete": "autocomplete-autocomplete-14IKJCEjmwr",
	"input": "autocomplete-input-54jl6Xfjmwr",
	"autocomplete-input-wrapper": "autocomplete-autocomplete-input-wrapper-1lhySFZlmwr",
	"autocompleteInputWrapper": "autocomplete-autocomplete-input-wrapper-1lhySFZlmwr"
};